export const AdminStats = ({ stats }) => (
  <div data-testid="admin-stats" className="space-y-8">
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      {[
        ["Incasso totale", `${stats.revenue.toFixed(2).replace(".", ",")} €`],
        ["Ordini pagati", stats.orders_paid],
        ["Ordine medio", `${stats.avg_order.toFixed(2).replace(".", ",")} €`],
        ["Incasso retail", `${stats.retail_revenue.toFixed(2).replace(".", ",")} €`],
        ["Incasso B2B", `${stats.b2b_revenue.toFixed(2).replace(".", ",")} €`],
      ].map(([l, v]) => (
        <div key={l} className="rounded-2xl border border-[#E7E0D8] bg-white p-5">
          <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C]">{l}</p>
          <p className="font-serif-display font-bold text-2xl mt-2 text-[#1C1917]">{v}</p>
        </div>
      ))}
    </div>

    <div className="grid lg:grid-cols-2 gap-6">
      <div className="rounded-2xl border border-[#E7E0D8] bg-white p-6" data-testid="admin-stats-top-dishes">
        <h3 className="font-serif-display font-bold text-xl mb-5">Piatti più venduti</h3>
        {stats.top_dishes.length === 0 && <p className="text-sm text-[#78716C]">Nessun dato ancora.</p>}
        <div className="space-y-3">
          {stats.top_dishes.map((d, i) => {
            const max = stats.top_dishes[0]?.quantity || 1;
            return (
              <div key={d.name}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="font-medium truncate pr-3">{i + 1}. {d.name}</span>
                  <span className="font-mono-accent text-xs text-[#78716C] shrink-0">{d.quantity} pz · {d.revenue.toFixed(2).replace(".", ",")} €</span>
                </div>
                <div className="h-2 rounded-full bg-[#F5F0EB] overflow-hidden">
                  <div className="h-full bg-[#2E8A57] rounded-full" style={{ width: `${(d.quantity / max) * 100}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="rounded-2xl border border-[#E7E0D8] bg-white p-6" data-testid="admin-stats-monthly">
        <h3 className="font-serif-display font-bold text-xl mb-5">Ordini per mese</h3>
        {stats.monthly.length === 0 && <p className="text-sm text-[#78716C]">Nessun dato ancora.</p>}
        <div className="space-y-3">
          {stats.monthly.map((m) => {
            const max = Math.max(...stats.monthly.map((x) => x.revenue), 1);
            const [y] = m.month.split("-");
            const monthName = new Date(`${m.month}-01T12:00:00`).toLocaleDateString("it-IT", { month: "long" });
            return (
              <div key={m.month}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="font-medium capitalize">{monthName} {y}</span>
                  <span className="font-mono-accent text-xs text-[#78716C]">{m.orders} ordini · {m.revenue.toFixed(2).replace(".", ",")} €</span>
                </div>
                <div className="h-2 rounded-full bg-[#F5F0EB] overflow-hidden">
                  <div className="h-full bg-[#7DC242] rounded-full" style={{ width: `${(m.revenue / max) * 100}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </div>
);
